import axios from 'axios'
import router from '@/router'
import Vue from 'vue'
import { Toast } from 'vant'
import { REQUEST_BASICS } from './request.config'
Vue.use(Toast)
const instance = axios.create({
    ...REQUEST_BASICS,
});
// 请求拦截，在请求头中加token
instance.interceptors.request.use(
    config => {
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        let token = localStorage.getItem('token')
        if (!config.headers.hasOwnProperty('Authorization') && token) {
            config.headers.Authorization = "bearer " + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });
// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    return response;

}, function(error) {
    return Promise.reject(error);
});

export default instance;
